module.exports = __webpack_public_path__ + "img/thumbnail_platform.68eb95cb.png";